import {isNil} from 'ramda';

import {PhotoCheckerMode} from '@dms/api/core';

import {parseDate} from 'shared/web';

import {getAlbumPhotosReferenceAt} from './isPhotoCheckerResultStale';

export function isPhotoCheckerAutoModeMissed(
  photosUpdatedAt: string | null | undefined,
  albumCreatedAt: string | null | undefined,
  automaticModeEnabledAt: string | null | undefined,
  reportCreatedAt: string | null | undefined,
  mode: PhotoCheckerMode
): boolean {
  if (mode !== 'auto') {
    return false;
  }

  const photosReferenceAt = getAlbumPhotosReferenceAt(photosUpdatedAt, albumCreatedAt);

  if (isNil(photosReferenceAt) || isNil(automaticModeEnabledAt)) {
    return false;
  }

  const photosReferenceTime = parseDate(photosReferenceAt)?.getTime();
  const automaticModeEnabledTime = parseDate(automaticModeEnabledAt)?.getTime();

  if (isNil(photosReferenceTime) || isNil(automaticModeEnabledTime)) {
    return false;
  }

  if (photosReferenceTime >= automaticModeEnabledTime) {
    return false;
  }

  if (isNil(reportCreatedAt)) {
    return true;
  }

  const reportCreatedTime = parseDate(reportCreatedAt)?.getTime();

  if (isNil(reportCreatedTime)) {
    return false;
  }

  return reportCreatedTime < automaticModeEnabledTime;
}
